import { axios, axiosHelper } from '@/axios';
import axiosForm from '@/axios/axiosForm';

export const eventService = {
  getMyPaginatednotifciation,
  getMyPaginatedActivity,
  getCategories,
  gethashtags,
  getPartners,
  postEvent,
  postTickets,
  updateTickets,
  getMyEvents,
  getMyProfileEvents,
  getMyPaginatedEvents,
  deleteEvent,
  getExploreEvents,
  getRecommendedEvents,
  getLikedEvents,
  getLovedEvents,
  getAttendingEvents,
  getEventDetails,
  getComments,
  postComment,
  attendEvent,
  likeEvent,
  loveEvent,
  unAttendEvent,
  unLikeEvent,
  unLoveEvent,
  getLocations,
  getServices,
  postFeedback,
  updateEvent,
  unamplifyEvent,
  getHistoryTickets,
  getPreviewTickets,
  getFetchTickets,
  unlockTickets,
  buyTickets,
  deleteTicket,
  reorderTickets,
  linkCheck,
  reedemcode,
  getMyPaginatedLiked,
  getMyPaginatedAttending,
  getMyPaginatedLoved,
  getPromoCodes,
  createPromo,
  updatePromo,
  changePromoStatus,
  getQuickpayLink,
};

function postFeedback(params) {
  return axios
    .post('/api/post_feedback', params)
    .then(axiosHelper.handleResponse)
    .then((result) => {
      return result;
    });
}
function getLocations(params) {
  return axios
    .post('/api/reverse_geocode', params)
    .then(axiosHelper.handleResponse)
    .then((result) => {
      return result;
    });
}
function getCategories() {
  return axios
    .get('/api/metadata', {})
    .then(axiosHelper.handleResponse)
    .then((categories) => {
      return categories['Result']['Categories'];
    });
}

function gethashtags() {
  return axios
    .get('/api/metadata', {})
    .then(axiosHelper.handleResponse)
    .then((categories) => {
      return categories['Result']['hashtags'];
    });
}

function getServices() {
  return axios
    .get('/api/metadata', {})
    .then(axiosHelper.handleResponse)
    .then((partners) => {
      return partners['Result']['services'];
    });
}

function getPartners() {
  return axios
    .get('/api/metadata', {})
    .then(axiosHelper.handleResponse)
    .then((partners) => {
      return partners['Result']['Community Partners'];
    });
}

function postEvent(eventData) {
  return axiosForm
    .post('/api/post_event', eventData)
    .then(axiosHelper.handleResponse)
    .then((postedEvent) => {
      return postedEvent.Result;
    })
    .catch((error) => {
      if (error.response.status === 400) {
        return Promise.reject(error.response.data.Message);
      }
    });
}

function updateEvent(eventData) {
  return axiosForm
    .post('/api/update_event', eventData)
    .then(axiosHelper.handleResponse)
    .then((updatedEvent) => {
      return updatedEvent.Result;
    })
    .catch((error) => {
      if (error.response.status === 400) {
        return Promise.reject(error.response.data.Message);
      }
    });
}

function unamplifyEvent(eventData) {
  return axios
    .post('/api/unamplify_event', eventData)
    .then(axiosHelper.handleResponse)
    .then((updatedEvent) => {
      return updatedEvent.Result;
    })
    .catch((error) => {
      if (error.response.status === 400) {
        return Promise.reject(error.response.data.Message);
      }
    });
}

function postTickets(ticketsData) {
  return axios
    .post('/api/add_tickets', ticketsData)
    .then(axiosHelper.handleResponse)
    .then((postedTickets) => {
      return postedTickets.Result;
    })
    .catch((error) => {
      if (error.response.status === 400) {
        return Promise.reject(error.response.data.Message);
      }
    });
}

function updateTickets(ticketsData) {
  return axios
    .post('/api/update_ticket', ticketsData)
    .then(axiosHelper.handleResponse)
    .then((postedTickets) => {
      return postedTickets;
    })
    .catch((error) => {
      if (error.response.status === 400) {
        return Promise.reject(error.response.data.Message);
      }
    });
}

function deleteEvent(params) {
  return axios
    .post('/api/delete_event', {
      userId: params.userId,
      eventCode: params.eventCode,
    })
    .then(axiosHelper.handleResponse)
    .then((myEvents) => myEvents);
}

function getMyEvents(params) {
  return axios
    .post('/api/fetch_events', {
      userId: params.userId,
      limit: '40',
      offset: '0',
    })
    .then(axiosHelper.handleResponse)
    .then((myEvents) => {
      return myEvents.Result;
    });
}

function getMyProfileEvents(params) {
  return axios
    .post('/api/fetch_profile_events', {
      userId: params.userId,
      limit: '40',
      offset: '0',
    })
    .then(axiosHelper.handleResponse)
    .then((myEvents) => {
      return myEvents.Result;
    });
}

function getMyPaginatedEvents(params) {
  return axios
    .post('/api/fetch_my_events_paginated', params)
    .then(axiosHelper.handleResponse)
    .then((myEvents) => {
      return myEvents.Result;
    });
}

function getMyPaginatedAttending(params) {
  return axios
    .post('/api/get_paginated_attending_events', params)
    .then(axiosHelper.handleResponse)
    .then((myEvents) => {
      return myEvents.Result;
    });
}

function getMyPaginatedLiked(params) {
  return axios
    .post('/api/get_paginated_liked_events', params)
    .then(axiosHelper.handleResponse)
    .then((myEvents) => {
      return myEvents.Result;
    });
}

function getMyPaginatedLoved(params) {
  return axios
    .post('/api/get_paginated_loved_events', params)
    .then(axiosHelper.handleResponse)
    .then((myEvents) => {
      return myEvents.Result;
    });
}

function getExploreEvents(params) {
  if (!params.price) {
    params.price = [0, 100000];
  }
  let options = {
    category: `${params.categoryId}`,
    userId: `${params.userId}`,
    miles: `${params.radius}`,
    minimumAge: params.age[0],
    maximumAge: params.age[1],
    minimumPrice: params.price[0],
    maximumPrice: params.price[1],
    fromDate: params.fromDate,
    toDate: params.toDate,
    sort: params.sort,
    size: 20,
    page: 1,
  };
  if (params.location) {
    options['latitude'] = params.location.lat;
    options['longitude'] = params.location.lng;
  }

  if (params.query) {
    options = {
      userId: `${params.userId}`,
      size: 10,
      page: params.page,
      query: params.query,
    };
  }

  return axios
    .post('/api/fetch_paginated_events', options)
    .then(axiosHelper.handleResponse)
    .then((exploreEvents) => {
      return exploreEvents.Result;
    });
}

function getEventDetails(params) {
  return axios
    .post('/api/fetch_event', params)
    .then(axiosHelper.handleResponse)
    .then((response) => {
      if (response.Result && response.Result.length < 1) {
        window.location = 'https://www.myle.com/404';
      }
      return response.Result;
    })
    .catch((err) => err);
}

function getComments(params) {
  return axios
    .post('/api/fetch_comments', params)
    .then(axiosHelper.handleResponse)
    .then((response) => {
      return response.Result;
    });
}

function postComment(params) {
  return axios
    .post('/api/create_comment', params)
    .then(axiosHelper.handleResponse)
    .then((response) => {
      return response.Result;
    });
}

function attendEvent(params) {
  return axios
    .post('/api/attend_event', params)
    .then(axiosHelper.handleResponse)
    .then((response) => {
      return response.Result;
    });
}

function likeEvent(params) {
  return axios
    .post('/api/event_liked', params)
    .then(axiosHelper.handleResponse)
    .then((response) => {
      return response.Result;
    });
}

function loveEvent(params) {
  return axios
    .post('/api/event_loved', params)
    .then(axiosHelper.handleResponse)
    .then((response) => {
      return response.Result;
    });
}

function unAttendEvent(params) {
  return axios
    .post('/api/unattend_event', params)
    .then(axiosHelper.handleResponse)
    .then((response) => {
      return response.Result;
    });
}

function unLikeEvent(params) {
  return axios
    .post('/api/event_un_liked', params)
    .then(axiosHelper.handleResponse)
    .then((response) => {
      return response.Result;
    });
}

function unLoveEvent(params) {
  return axios
    .post('/api/event_un_loved', params)
    .then(axiosHelper.handleResponse)
    .then((response) => {
      return response.Result;
    });
}

function getRecommendedEvents(userId, categoryId) {
  return axios
    .post('/api/fetch_my_events', {
      userId: userId,
      category: categoryId,
      miles: '20.000000',
    })
    .then(axiosHelper.handleResponse)
    .then((recommendedEvents) => {
      return recommendedEvents.Result;
    });
}
function getLikedEvents(userId) {
  return axios
    .post('/api/get_liked_events', {
      userId: userId,
    })
    .then(axiosHelper.handleResponse)
    .then((response) => {
      return response.Result;
    });
}

function getLovedEvents(userId) {
  return axios
    .post('/api/get_loved_events', {
      userId: userId,
    })
    .then(axiosHelper.handleResponse)
    .then((response) => {
      return response.Result;
    });
}

function getAttendingEvents(userId) {
  return axios
    .post('/api/get_attending_events', {
      userId: userId,
    })
    .then(axiosHelper.handleResponse)
    .then((response) => {
      return response.Result;
    });
}

/**
 * This function here is used to fetch history tickets
 * @params userId Id of user
 * @returns fetched data promise
 */
function getHistoryTickets(userId) {
  return axios
    .post('/api/request_ticket_orders', {
      userId: userId,
    })
    .then(axiosHelper.handleResponse)
    .then((response) => response)
    .catch((error) => error);
}

/**
 * This function here is used to preview specific ticket
 * @params order Id of user
 * @returns fetched data promise
 */
function getPreviewTickets(orderId) {
  return axios
    .post('/api/preview_tickets', {
      orderId: orderId,
    })
    .then(axiosHelper.handleResponse)
    .then((response) => response)
    .catch((error) => error);
}

/**
 * This function here is used to preview specific ticket
 * @params order Id of user
 * @returns fetched data promise
 */
function getFetchTickets(eventId) {
  return axios
    .post('/api/fetch_tickets', {
      eventId: eventId,
    })
    .then(axiosHelper.handleResponse)
    .then((response) => response)
    .catch((error) => error);
}

function unlockTickets(body) {
  return axios
    .post('/api/unlock_tickets', body)
    .then(axiosHelper.handleResponse)
    .then((response) => response)
    .catch((error) => error);
}

/**
 * This function here is used to preview specific ticket
 * @params order Id of user
 * @returns fetched data promise
 */
function buyTickets(body) {
  return axios.post('/api/request_tickets_webapp', body);
}

/**
 * This function here is used to delete specific ticket
 * @params body
 * @returns fetched data promise
 */
function deleteTicket(body) {
  return axios
    .post('/api/delete_ticket', body)
    .then(axiosHelper.handleResponse)
    .then((response) => response)
    .catch((error) => error);
}

/**
 * This function here is used to delete specific ticket
 * @params body
 * @returns fetched data promise
 */
function reorderTickets(body) {
  return axios
    .post('/api/update_ticket_order', body)
    .then(axiosHelper.handleResponse)
    .then((response) => response)
    .catch((error) => error);
}

/**
 * This function here is used to delete specific ticket
 * @params body
 * @returns fetched data promise
 */
function linkCheck(body) {
  return axios
    .post('/api/validate_custom_url', body)
    .then(axiosHelper.handleResponse)
    .then((response) => response)
    .catch((error) => error);
}

/**
 * This function here is used to delete specific ticket
 * @params body
 * @returns fetched data promise
 */
function reedemcode(body) {
  return axios
    .post('/api/redeem_promo_code', body)
    .then(axiosHelper.handleResponse)
    .then((response) => response)
    .catch((error) => error);
}

function getMyPaginatedActivity(params) {
  return axios
    .post('/api/fetch_paginated_activity', params)
    .then(axiosHelper.handleResponse)
    .then((myEvents) => {
      return myEvents.Result;
    });
}

function getMyPaginatednotifciation(params) {
  return axios
    .post('/api/fetchPaginatedPushNotifications', params)
    .then(axiosHelper.handleResponse)
    .then((myEvents) => {
      return myEvents.Result;
    });
}

function getPromoCodes(params) {
  return axios
    .post('/api/fetch_ticket_promo_codes', params)
    .then(axiosHelper.handleResponse);
}

function createPromo(body) {
  return axios
    .post('/api/generate_ticket_promo_code', body)
    .then(axiosHelper.handleResponse);
}

function updatePromo(body) {
  return axios
    .post('/api/update_ticket_promo_codes', body)
    .then(axiosHelper.handleResponse);
}

function changePromoStatus(body) {
  return axios
    .post('/api/change_ticket_promo_code_status', body)
    .then(axiosHelper.handleResponse);
}

function getQuickpayLink(eventCode) {
  return axios
    .post('/api/event_ticket_quickpay_link', { eventCode: eventCode })
    .then(axiosHelper.handleResponse)
    .catch(function () {
      return { ready: false, status: null, url: null };
    });
}
